/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EntityModelResponseContainerCountryDto } from '../models/EntityModelResponseContainerCountryDto';
import type { EntityModelResponseContainerMapStringString } from '../models/EntityModelResponseContainerMapStringString';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ProgramCountryControllerService {
    /**
     * @returns EntityModelResponseContainerCountryDto OK
     * @throws ApiError
     */
    public static read(): CancelablePromise<EntityModelResponseContainerCountryDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/program/country',
        });
    }
    /**
     * @returns EntityModelResponseContainerMapStringString OK
     * @throws ApiError
     */
    public static readCodes(): CancelablePromise<EntityModelResponseContainerMapStringString> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/program/country/codes',
        });
    }
}
